{
  "title": "Identifier l'aéronef inconnu",
  "description": "Appareils non identifiés lors de l'importation de données. Sélectionnez un type d'appareil pour créer un locataire. Un administrateur examinera et approuvera l'association FAA ultérieurement.",
  "alerts": {
    "noActiveFBO": "Aucun FBO actif sélectionné",
    "noPendingAircraft": "Aucun aéronef en attente - tous les aéronefs synchronisés ont été associés !"
  },
  "toolbar": {
    "refresh": "Actualiser",
    "pendingCount": "Nombre en attente"
  },
  "table": {
    "headers": {
      "tailNumber": "Immatriculation",
      "typeHint": "Type d'indice",
      "operator": "Opérateur",
      "mapToAircraft": "Associer à l'aéronef",
      "created": "Créé"
    },
    "empty": "Aucun aéronef en attente",
    "processing": "Création du client...",
    "selectAircraft": "Sélectionner l'aéronef"
  },
  "messages": {
    "userNotAuthenticated": "Utilisateur non authentifié",
    "mappingFailed": "Échec du mappage de l'appareil"
  },
  "fallbacks": {
    "unknownOperator": "Inconnu",
    "unknownType": "Inconnu"
  }
}
